import {
    Flex,
    HStack,
    IconButton,
    Text,
    useColorMode,
    Tooltip,
    Box,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { TbMap2, TbAntenna, TbUsers, TbInfoCircle } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import SobreNos from "views/Public/Components/SobreNos";

export default function HeaderLinks(props) {
    const { variant, children, secondary, onOpen, ...rest } = props;
    const [isSobreNosOpen, setIsSobreNosOpen] = useState(false);
    const location = useLocation();
    const { colorMode, toggleColorMode } = useColorMode();

    // Navigation items configuration
    const navItems = [
        { path: "/", label: "Mapa", icon: TbMap2 },
        { path: "/estacoes", label: "Estações", icon: TbAntenna },
        { path: "/members/home", label: "Membros", icon: TbUsers },
    ];

    // Check if current path matches nav item
    const isActive = (path) => {
        if (path === "/") return location.pathname === "/";
        return location.pathname.startsWith(path);
    };

    return (
        <Flex
            w={{ base: "100%", md: "auto" }}
            alignItems="center"
            justifyContent={{ base: "center", md: "flex-end" }}
            flexDirection="row"
            gap={{ base: 1, md: 2 }}
        >
            <HStack spacing={{ base: 0, md: 1 }}>
                {navItems.map((item) => (
                    <Link to={item.path} key={item.path}>
                        <Box
                            px={{ base: 2, md: 3 }}
                            py={1.5}
                            borderRadius="lg"
                            bg={isActive(item.path) ? "whiteAlpha.200" : "transparent"}
                            transition="all 0.2s ease"
                            _hover={{
                                bg: "whiteAlpha.200",
                                transform: "translateY(-1px)",
                            }}
                            cursor="pointer"
                        >
                            <HStack spacing={1.5}>
                                <item.icon size={14} color="white" />
                                <Text
                                    fontSize="sm"
                                    color="white"
                                    fontWeight={isActive(item.path) ? "semibold" : "medium"}
                                    display={{ base: "none", sm: "block" }}
                                >
                                    {item.label}
                                </Text>
                            </HStack>
                        </Box>
                    </Link>
                ))}

                {/* About Button */}
                <Box
                    px={{ base: 2, md: 3 }}
                    py={1.5}
                    borderRadius="lg"
                    transition="all 0.2s ease"
                    _hover={{
                        bg: "whiteAlpha.200",
                        transform: "translateY(-1px)",
                    }}
                    cursor="pointer"
                    onClick={() => setIsSobreNosOpen(true)}
                >
                    <HStack spacing={1.5}>
                        <TbInfoCircle size={14} color="white" />
                        <Text
                            fontSize="sm"
                            color="white"
                            fontWeight="medium"
                            display={{ base: "none", sm: "block" }}
                        >
                            Sobre
                        </Text>
                    </HStack>
                </Box>
            </HStack>

            {/* Divider */}
            <Box
                h="24px"
                w="1px"
                bg="whiteAlpha.300"
                mx={{ base: 1, md: 2 }}
                display={{ base: "none", sm: "block" }}
            />

            {/* Dark Mode Toggle */}
            <Tooltip
                label={colorMode === "light" ? "Modo escuro" : "Modo claro"}
                placement="bottom"
                hasArrow
            >
                <IconButton
                    aria-label="Toggle color mode"
                    icon={colorMode === "light" ? <FaMoon size={14} /> : <FaSun size={14} />}
                    onClick={toggleColorMode}
                    variant="ghost"
                    color="white"
                    size="sm"
                    borderRadius="lg"
                    _hover={{
                        bg: "whiteAlpha.200",
                        transform: "translateY(-1px)",
                    }}
                    transition="all 0.2s ease"
                />
            </Tooltip>

            <SobreNos isOpen={isSobreNosOpen} setIsOpen={setIsSobreNosOpen} />
        </Flex>
    );
}
